import React, { useState } from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { getOwnerMenuItems } from '../../components/layout/OwnerMenuConfig';
import {
  AnalyticsContainer,
  AnalyticsHeader,
  DateRangeSelector,
} from './analytics/Analytics.styles';
import Engagement from './analytics/Engagement';

const EngagementPage = () => {
  const menuItems = getOwnerMenuItems();
  
  const getDefaultStartDate = () => {
    const date = new Date();
    date.setDate(date.getDate() - 30);
    return date.toISOString().split('T')[0];
  };
  
  const [startDate, setStartDate] = useState(getDefaultStartDate());
  const [endDate, setEndDate] = useState(new Date().toISOString().split('T')[0]);

  return (
    <DashboardLayout menuItems={menuItems}>
      <AnalyticsContainer>
        <AnalyticsHeader>
          <div>
            <h1>Engagement Analytics 🔥</h1>
            <p>Track platform-wide user engagement metrics</p>
          </div>
          
          <DateRangeSelector>
            <label htmlFor="start-date">Start Date:</label>
            <input
              type="date"
              id="start-date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              max={endDate}
            />
            <label htmlFor="end-date">End Date:</label>
            <input
              type="date"
              id="end-date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              min={startDate}
              max={new Date().toISOString().split('T')[0]}
            />
          </DateRangeSelector>
        </AnalyticsHeader>

        <Engagement startDate={startDate} endDate={endDate} />
      </AnalyticsContainer>
    </DashboardLayout>
  );
};

export default EngagementPage;

